import { createSlice } from '@reduxjs/toolkit';
import { FEATURE_NAME } from 'src/redesign/features/AttendeesSidebar/store/constants';
import { AttendeeSidebarState } from 'src/redesign/features/AttendeesSidebar/types';
import {
  getAttendeeDataById,
  updateAttendeeData,
} from 'src/redesign/features/AttendeesSidebar/store/actions';

const initialState: AttendeeSidebarState = {
  view: null,
  currentAttendee: null,
  show: false,
  attendeeData: null,
  error: null,
  loading: false,
  updateError: null,
  updateLoading: false,
};

export const attendeeSidebarSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    attendeesSidebarChangeView: (state, action) => {
      state.view = action.payload;
      state.show = Boolean(action.payload);
    },
    attendeesSidebarChangeAttendee: (state, action) => {
      state.currentAttendee = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAttendeeDataById.fulfilled, (state, action) => {
      state.attendeeData = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getAttendeeDataById.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAttendeeDataById.rejected, (state, action) => {
      state.error = action.error.message;
    });
    builder.addCase(updateAttendeeData.fulfilled, (state) => {
      state.updateLoading = false;
      state.updateError = null;
    });
    builder.addCase(updateAttendeeData.rejected, (state, action) => {
      state.updateLoading = false;
      state.updateError = action.error.message;
    });
    builder.addCase(updateAttendeeData.pending, (state) => {
      state.updateLoading = true;
      state.updateError = null;
    });
  },
});

export const attendeesSidebarChangeView = attendeeSidebarSlice.actions.attendeesSidebarChangeView;

export const attendeesSidebarChangeAttendee =
  attendeeSidebarSlice.actions.attendeesSidebarChangeAttendee;
